import { scrapeHubupPageUrl } from '../api/hubup';

const STORAGE_PREFIX = 'hubup-generate-draft-notice:';

/** @type {{ groupId: string, inFlight: boolean, openFormWhenDone: boolean, promise?: Promise<any> } | null} */
let active = null;

const listeners = new Set();

function snapshot() {
  if (!active?.inFlight) {
    return { inFlight: false, groupId: null };
  }
  return { inFlight: true, groupId: active.groupId };
}

function notifyListeners() {
  const s = snapshot();
  listeners.forEach((fn) => {
    try {
      fn(s);
    } catch {
      /* ignore */
    }
  });
}

export function subscribeHubupGenerateJob(listener) {
  listeners.add(listener);
  listener(snapshot());
  return () => listeners.delete(listener);
}

export function getHubupGenerateJobSnapshot() {
  return snapshot();
}

/** L'utilisateur a fermé la modale ou quitté la page : ne pas ouvrir le formulaire. */
export function deferHubupGenerateOpenForm() {
  if (active?.inFlight) {
    active.openFormWhenDone = false;
  }
}

export function consumeHubupGenerateDraftNotice(groupId) {
  try {
    const key = `${STORAGE_PREFIX}${String(groupId ?? '').trim()}`;
    const id = sessionStorage.getItem(key);
    if (id) sessionStorage.removeItem(key);
    return id;
  } catch {
    return null;
  }
}

function rememberDraftNotice(groupId, draftId) {
  if (!groupId || !draftId) return;
  try {
    sessionStorage.setItem(
      `${STORAGE_PREFIX}${String(groupId)}`,
      String(draftId),
    );
  } catch {
    /* ignore */
  }
}

/**
 * Scrape page + brouillon (API). La promesse continue si la page React est démontée.
 */
export function runHubupGenerateNotificationJob(groupId, url, language = 'fr') {
  const gid = String(groupId ?? '').trim();
  if (!gid) {
    return Promise.reject(new Error('Communauté invalide.'));
  }

  if (active?.inFlight && active.groupId === gid && active.promise) {
    return active.promise;
  }

  const job = {
    groupId: gid,
    inFlight: true,
    openFormWhenDone: true,
    promise: undefined,
  };
  active = job;

  job.promise = (async () => {
    notifyListeners();
    try {
      const res = await scrapeHubupPageUrl(gid, { url, language });
      const draft = res?.data?.draft;
      const openFormWhenDone = job.openFormWhenDone;

      if (!openFormWhenDone && draft?._id) {
        rememberDraftNotice(gid, draft._id);
      }

      return {
        ok: true,
        groupId: gid,
        draft,
        suggestedMedia: Array.isArray(res?.data?.suggestedMedia)
          ? res.data.suggestedMedia
          : [],
        openFormWhenDone,
        data: res?.data,
      };
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      return {
        ok: false,
        groupId: gid,
        error: err,
        openFormWhenDone: job.openFormWhenDone,
      };
    } finally {
      job.inFlight = false;
      notifyListeners();
      if (active === job) {
        active = null;
      }
    }
  })();

  return job.promise;
}
